import React, {Component} from 'react';
import '../css/Web_main.css';
import Sub from './Sub';
import $ from 'jquery';
import WOW from "wow.js";
import '../css/Animated.css'

class Web_main extends Component{
  constructor(props){
    super(props)
    this.state={
    }
  }

  componentDidMount(){
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null,    // optional scroll container selector, otherwise use window,
        resetAnimation: true,     // reset animation on end (default is true)
      }
    );
    wow.init();

    $(window).scroll(function(){
      var height = $(document).scrollTop();
      console.log(height);
      if(height > 859){
        $('.main_bottom>.menuBar').addClass('fixed');
        $('.main_bottom>.menuBar').css({'height':'80px', 'background-color':'#fff','padding-top': '30px'})
      }else if(height <= 859){
        $('.main_bottom>.menuBar').removeClass('fixed');
      }
    })
    this.moveScroll()
    this.arrowBtn()
  }
  
  moveScroll(){
    $(window).scroll(function(){
      var height = $(document).scrollTop();
      //console.log(height);
      if(height >= 880 && height <1780){
        $('.menuBar>ul>li:first-child>a').css('color','#333')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#c3c3c3')
      }else if(height >= 1780 && height <2680){
        $('.menuBar>ul>li:first-child>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#333')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#c3c3c3')
      }else if(height >= 2680 && height <3580){
        $('.menuBar>ul>li:first-child>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#333')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#c3c3c3')
      }else if(height >= 3580 && height <4480){
        $('.menuBar>ul>li:first-child>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#333')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#c3c3c3')
      }else if(height >= 4480 && height <5380){
        $('.menuBar>ul>li:first-child>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#333')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#c3c3c3')
      }else if(height >= 5380 && height <6280){
        $('.menuBar>ul>li:first-child>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#333')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#c3c3c3')
      }else if(height >= 6280 && height <7180){
        $('.menuBar>ul>li:first-child>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(2)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(3)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(4)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(5)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(6)>a').css('color','#c3c3c3')
        $('.menuBar>ul>li:nth-child(7)>a').css('color','#333')
      }else{
        $('.menuBar>ul li a').css('color','#c3c3c3')
      }
    })
    $('.menuBar>ul>li:first-child>a').click(function(){
      //console.log('공동육아')
      var offset = $('.chap01').offset();
      $('html').animate({scrollTop : offset.top}, 600);
    })
    $('.menuBar>ul>li:nth-child(2)>a').click(function(){
      var offset = $('.chap02').offset()
      $('html').animate({scrollTop : offset.top}, 600);
    })
    $('.menuBar>ul>li:nth-child(3)>a').click(function(){
      var offset = $('.chap03').offset()
      $('html').animate({scrollTop : offset.top}, 600);
    })
    $('.menuBar>ul>li:nth-child(4)>a').click(function(){
      var offset = $('.chap04').offset()
      $('html').animate({scrollTop : offset.top}, 600);
    })
    $('.menuBar>ul>li:nth-child(5)>a').click(function(){
      var offset = $('.chap05').offset()
      $('html').animate({scrollTop : offset.top}, 600);
    })
    $('.menuBar>ul>li:nth-child(6)>a').click(function(){
      var offset = $('.chap06').offset()
      $('html').animate({scrollTop : offset.top}, 600);
    })
    $('.menuBar>ul>li:nth-child(7)>a').click(function(){
      var offset = $('.chap07').offset()
      $('html').animate({scrollTop : offset.top}, 600);
    })
  }

  arrowBtn(){
    $(window).scroll(function(){
      if ($(this).scrollTop() < 300){
        $('.arrow_icon').hide();
      } else{
        $('.arrow_icon').show();
      }
    });
    $('.arrow_icon').click(function(){
      $('html, body').animate({scrollTop:0},400);
      return false;
    });
  }

  render(){
    return(
      <div className='Web_main'>
        <div className='main_top'>
            <img src = "img/main_top.jpg"  alt='메인최상단이미지'/>
            <div className='maintext'>
                <a href='#'><img src='img/logo02.png' alt='도닥맘마로고'/></a>
                <div>이유있는 선택</div>
                <div>도닥맘마</div>
                <div>맞춤식단</div>
                <div>우리 아이 건강 상태에 맞춘 영양 가득한 식단</div>
                <button>앱 다운로드</button>
            </div>
        </div>
        <div className='main_bottom'>
            <div className='menuBar'>
                <ul>
                    <li><a href='#'>공동육아</a></li>
                    <li><a href='#'>질문</a></li>
                    <li><a href='#'>기록</a></li>
                    <li><a href='#'>포인트</a></li>
                    <li><a href='#'>기부</a></li>
                    <li><a href='#'>리포트</a></li>
                    <li><a href='#'>맞춤식단</a></li>
                </ul>
            </div>
        </div>
        <img className='wow fadeInUp arrow_icon' src='img/arrow_icon.png' alt='상단으로 이동' title='최상단이동'/>
        <button className='chat_bot'>
          <img src='img/chat_bot.png' alt='챗봇' title='상담센터 연결하기'/>
        </button>
        <Sub/>
      </div>
    )
  }
}

export default Web_main;
